export default "__VITE_ASSET__BhMAq8HG__"